export interface RequestKlubCategoryNameInterface {
  klubCategory?: string;
  limit?: number;
  page?: number;
}

export interface ThumbImage {
  image_4x3: string;
  image_16x9: string;
}

export class ResponseKlubCategoryListInterface {
  id: number;

  slug: string;

  storyId: number;

  contentType: string;

  type: string;

  isPromotion: boolean;

  thumbImage: ThumbImage;

  title: string;

  location?: {
    city?: string;
    citySlug?: string;
    name?: string;
  };

  user?: {
    avatar?: string;
    name?: string;
  };

  constructor(data: any) {
    this.id = data?.id || 0;
    this.slug = data.slug || "";
    this.storyId = data.storyId || 0;
    this.contentType = data.contentType || "";
    this.type = data.type || "";
    this.isPromotion = data.isPromotion || false;
    this.thumbImage = {
      image_4x3: data.thumbImage?.image_4x3 || "",
      image_16x9: data.thumbImage?.image_16x9 || "",
    };
    this.title = data.title || "";
    this.location = {
      city: data.location?.city || "",
      citySlug: data.location?.citySlug || "",
      name: data.location?.name || "",
    };
    this.user = {
      avatar: data.user?.avatar || "",
      name: data.user?.name || "",
    };
  }
}
